import $ from "jquery";
import {gsap} from "gsap/all";
import {Gauge} from "./Gauge";
import {BaseGameMars} from "../base/BaseGameMars";
import nunjucks from "nunjucks";

export class TeamReport {

  constructor(app) {
    this.app = app;

    this.selectedCrewType = null
    this.currentTimeline = null
    this.topAptitudeGauges = {}

    this.init();
  }

  init() {

    // Init top aptitude gauges
    $("#screen-7 .aptitude").each((i, el) => {
      const gauge = new Gauge($(el));
      const id = $(el).data("id");
      this.topAptitudeGauges[id] = gauge;
    });
  }

  selectCrewType(crewId) {
    this.selectedCrewType = crewId;
    const crewData = this.app.data.content.team_role[crewId];

    // Add content to DOM (replace top screen content)
    $("#screen-7 .crew-report").attr("data-crew-id", crewId);
    $("#screen-7 .crew-report").attr("data-colors", crewData.glowColors.join(','));
    $("#screen-7 .crew-report").attr("data-members-count", crewData.number_members);

    // Update top screen values: image and title
    $("#screen-7 .team-icon img").attr("src", crewData.image);
    $("#screen-7 .team-title .fr").text(crewData.title.fr);
    $("#screen-7 .team-title .en").text(crewData.title.en);

    // Update top screen values: timeline
    crewData.timeline.forEach((event, i) => {
      const $event = $(`#event_${i + 1}`);
      $event.find("h4 .fr").html(event.title.fr);
      $event.find("h4 .en").html(event.title.en);
      $event.find("p .fr").html(event.text.fr);
      $event.find("p .en").html(event.text.en);
    });
  }

  renderTeamReport(selectedMembers, teamTopAptitudes, requirementCounts, aptitudeSums) {

    const $target = $("#screen-7 .group-team-selected");

    // Clear anything from a previous run before re-rendering
    $target.find(".team-report-member").remove();

    selectedMembers.forEach((memberId) => {
      const member = this.app.data.content.team_members.members_list[memberId];
      if (!member) return;

      // Render member slot from nunjucks external template
      const $card = $(nunjucks.render('templates/build-your-team/team-report-member-selected.twig.html', {
        data: this.app.data,
        member: member,
        memberId: memberId,
      }));

      // Add slot content to DOM
      $target.append($card);
    });

    this.renderTeamTopAptitudes(teamTopAptitudes);
    this.renderCompletedTasks(requirementCounts);
    this.renderUnexpectedEvent(aptitudeSums);
    this.renderWrongTeamMessage();
  }

  // Shown instead of the unexpected event when a requirement or an aptitude was missed
  renderWrongTeamMessage() {
    const message = this.app.data.content.team_role[this.selectedCrewType].wrong_team_message;
    const $box = $("#screen-7 .unexpected-event .event-not-achieved");

    $box.find(".wrong-team-title .fr").html(message ? message.title.fr : "");
    $box.find(".wrong-team-title .en").html(message ? message.title.en : "");
    $box.find(".wrong-team-text .fr").html(message ? message.text.fr : "");
    $box.find(".wrong-team-text .en").html(message ? message.text.en : "");
  }

  // The event comes from the team's most filled non goal aptitude. Only non goal aptitudes have
  // an event in the data, so picking among the crew's events leaves the goals out on its own.
  // Events are stored in aptitude order and only a strictly higher score replaces the pick,
  // so a tie goes to the first one in the list.
  renderUnexpectedEvent(aptitudeSums) {
    const events = this.app.data.content.team_role[this.selectedCrewType].unexpected_events || [];

    let pickedEvent = null;
    let pickedSum = -1;
    events.forEach((event) => {
      const sum = aptitudeSums[event.aptitude] || 0;
      if (sum > pickedSum) {
        pickedEvent = event;
        pickedSum = sum;
      }
    });

    const $text = $("#screen-7 .unexpected-event .event-achieved .text-2");
    $text.find(".fr").html(pickedEvent ? pickedEvent.text.fr : "");
    $text.find(".en").html(pickedEvent ? pickedEvent.text.en : "");
    $("#screen-7 .unexpected-event img").attr("src", pickedEvent ? pickedEvent.image : "");
  }

  renderTeamTopAptitudes(teamTopAptitudes) {
    this.hasUnachievedVisibleAptitude = false;

    for (let [aptitudeId, gauge] of Object.entries(this.topAptitudeGauges)) {

      // We use the findIndex() instead of find() to use the index to match order of DOM with order of array
      const positionInLeaderboard = teamTopAptitudes.findIndex(aptitude => aptitude.id === aptitudeId)

      const targetPct = parseFloat($(`.group-team-aptitudes .aptitude[data-id="${aptitudeId}"]`).attr("data-target"));
      gauge.setTarget(targetPct);

      if (positionInLeaderboard !== -1) {
        const currentLevel = teamTopAptitudes[positionInLeaderboard].level
        gauge.container.show();
        gauge.animateToLevel(currentLevel);
        gauge.container.addClass("visible");
        gauge.container.css("order", positionInLeaderboard)

        const isAchieved = currentLevel >= targetPct;
        if (!isAchieved) this.hasUnachievedVisibleAptitude = true;
      } else {
        gauge.container.hide();
        gauge.container.removeClass("visible");
        gauge.container.css("order", "")
        // gauge.animateToLevel(20);
      }
    }
  }

  renderCompletedTasks(requirementCounts) {
    const crewData = this.app.data.content.team_role[this.selectedCrewType];

    // Render requirement item from nunjucks external template, followed by the crew's other tasks
    const renderedRequirements = nunjucks.render('templates/build-your-team/team-builder-requirement.twig.html', {
      data: this.app.data,
      requirements: crewData.requirements.concat(crewData.completed_tasks || [])
    });
    $("#screen-7 .tasks-completed .listings").html(renderedRequirements);

    // Toggle complete class
    $("#screen-7 .tasks-completed .listings .requirement").each((i, el) => {
      const $el = $(el);
      const id = $el.data("id");
      const count = requirementCounts[id] || 0;
      // The other tasks have no requirement id, no member is needed for them so they are always completed
      const isAchieved = !id || count > 0;

      $el.toggleClass("is-achieved", isAchieved);
      $el.toggleClass("not-achieved", !isAchieved);
    })

    // Check if any has not-achivied
    const hasUnachievedRequirement = $("#screen-7 .tasks-completed .listings .requirement.not-achieved").length > 0;

    $("#screen-7").toggleClass("has-unachieved", hasUnachievedRequirement || this.hasUnachievedVisibleAptitude);

    // Animate in
    BaseGameMars.killTimeline(this.currentTimeline)
    this.currentTimeline = gsap.timeline();
    this.currentTimeline.fromTo($("#screen-7 .tasks-completed .listings .requirement"),
      {
        alpha: 0,
        x: -20
      },
      {
        alpha: 1,
        x: 0,
        duration: 0.5,
        // Spread over 2 seconds whatever the number of tasks
        stagger: {amount: 2},
        ease: "power2.out"
      },
      1.5
    );
  }

  reset() {
    BaseGameMars.killTimeline(this.currentTimeline)
    this.selectedCrewType = null
    for (const id in this.topAptitudeGauges) this.topAptitudeGauges[id].reset();
  }
}
